module.exports = __webpack_public_path__ + "static/img/banner-03.cb328bea.png";